import { render } from "./MailCard.vue?vue&type=template&id=40084e64&scoped=true"
import script from "./MailCard.vue?vue&type=script&lang=js"
export * from "./MailCard.vue?vue&type=script&lang=js"

import "./MailCard.vue?vue&type=style&index=0&id=40084e64&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40084e64"]])

export default __exports__